import { api } from '@/fsd/shared/api';

interface IParams {
  step_key: string;
  finished?: boolean;
}

export const accountCabinetOnboardingProgress = async (data: IParams) => {
  return await api.post<{ current_step_key: string }>(
    `/api/v1/account/cabinet/onboarding/progress/`,
    {
      body: { ...data },
    }
  );
};
